/**
 * Helpers para disparo de eventos de conversão no Meta Pixel.
 * Cada evento representa uma etapa distinta do funil:
 * - Lead: Disparado exclusivamente quando o usuário envia seus dados no formulário/modal.
 * - Contact: Disparado em cliques manuais para abrir o WhatsApp.
 */

export const trackContact = () => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "Contact");
    console.log(
      "%c🎯 [Meta Pixel] Evento: Contact",
      "background: #25D366; color: #fff; font-weight: bold; padding: 2px 8px; border-radius: 4px;"
    );
  }
};

export const trackLead = () => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "Lead");
    console.log(
      "%c🎯 [Meta Pixel] Evento: Lead",
      "background: #1877F2; color: #fff; font-weight: bold; padding: 2px 8px; border-radius: 4px;"
    );
  }
};
